module.exports = __webpack_public_path__ + "img/ZJ5270.2dcb125c.png";